import { Typography as Typography$1, InputAdornment, CircularProgress, Box as Box$1, DialogContent, useTheme, useMediaQuery, AlertTitle, MenuItem, IconButton as IconButton$1 } from '@mui/material';
export * from '@mui/material';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import React, { useState, useMemo, useRef, useEffect, createElement } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import MuiTextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import MuiSwitch from '@mui/material/Switch';
import MuiButton from '@mui/material/Button';
import MuiDialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import MuiPagination from '@mui/material/Pagination';
import MUICheckbox$1 from '@mui/material/Checkbox';
import MUIAlert$1 from '@mui/material/Alert';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MuiRadio from '@mui/material/Radio';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import InputAdornment$1 from '@mui/material/InputAdornment';
import Paper from '@mui/material/Paper';
import MuiCard$1 from '@mui/material/Card';
import MuiList from '@mui/material/List';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import useRadioGroup from '@mui/material/RadioGroup/useRadioGroup';
import Typography$2 from '@mui/material/Typography';

var Palette = /* @__PURE__ */ ((Palette2) => {
  Palette2["BLACK"] = "#000000";
  Palette2["DARKER_GRAY"] = "#303030";
  Palette2["DARK_GRAY"] = "#767676";
  Palette2["GRAY"] = "#AEAEAE";
  Palette2["LIGHT_GRAY"] = "#E8E8E8";
  Palette2["BACKGROUND"] = "#F4F4F4";
  Palette2["WHITE"] = "#FFFFFF";
  Palette2["DARKER_PURPLE"] = "#271B3C";
  Palette2["DARK_PURPLE"] = "#382757";
  Palette2["DARK_PURPLE_TRANSPARENT"] = "#382757D6";
  Palette2["DARK_PURPLE_LIGHTER_TRANSPARENT"] = "#3827571A";
  Palette2["DARKER_VIOLET"] = "#7027B9";
  Palette2["VIOLET"] = "#8333D4";
  Palette2["VIOLET_TRANSPARENT"] = "#8333D466";
  Palette2["VIOLET_LIGHT_TRANSPARENT"] = "#8333D41A";
  Palette2["VIOLET_LIGHTER_TRANSPARENT"] = "#8333D40D";
  Palette2["LIGHT_VIOLET"] = "#BB86FC";
  Palette2["LIGHT_VIOLET_TRANSPARENT"] = "#BB86FC80";
  Palette2["DARK_GREEN"] = "#00804A";
  Palette2["GREEN"] = "#29D3A2";
  Palette2["GREEN_TRANSPARENT"] = "#29D3A21A";
  Palette2["RED"] = "#BD0013";
  Palette2["RED_TRANSPARENT"] = "#BD001314";
  Palette2["RED_LIGHTER_TRANSPARENT"] = "#BD001308";
  Palette2["FPO_MAGENTA"] = "#FF00FF";
  Palette2["FUSCHIA"] = "#CE5DCB";
  Palette2["PLUM"] = "#D39BD3";
  Palette2["WATERMELON"] = "#FF5667";
  Palette2["WATERMELON_TRANSPARENT"] = "#FF56671A";
  Palette2["CORAL"] = "#F08570";
  Palette2["AZALEA"] = "#F9B5B2";
  Palette2["AZALEA_TRANSPARENT"] = "#F9B5B266";
  Palette2["AZALEA_LIGHT_TRANSPARENT"] = "#F9B5B240";
  Palette2["AZALEA_LIGHTER_TRANSPARENT"] = "#F9B5B21A";
  Palette2["DARK_ORANGE"] = "#D14507";
  Palette2["ORANGE"] = "#FF8100";
  Palette2["TANGERINE"] = "#FEA500";
  Palette2["TANGERINE_TRANSPARENT"] = "#FEA5001A";
  Palette2["APRICOT"] = "#FCD7B6";
  Palette2["JADE"] = "#00B874";
  Palette2["SEAFOAM"] = "#9FF4D9";
  Palette2["DARK_GOLD"] = "#C78500";
  Palette2["PREMIUM_GOLD"] = "#EBB551";
  Palette2["PREMIUM_GOLD_TRANSPARENT"] = "#EBB55180";
  Palette2["LIGHT_GOLD"] = "#FEE4A4";
  Palette2["PREMIUM_LIGHT_YELLOW"] = "#FFFCF6";
  Palette2["SUNBURN"] = "#C14F24";
  Palette2["ALERT_SUCCESS"] = "#2D4929";
  Palette2["ALERT_INFO"] = "#1A425E";
  Palette2["ALERT_WARNING"] = "#634215";
  Palette2["ALERT_ERROR"] = "#582522";
  Palette2["ALERT_SUCCESS_LIGHTER"] = "#EFF7EE";
  Palette2["ALERT_INFO_LIGHTER"] = "#E8F5FC";
  Palette2["ALERT_WARNING_LIGHTER"] = "#FDF4E7";
  Palette2["ALERT_ERROR_LIGHTER"] = "#FAEEED";
  return Palette2;
})(Palette || {});
var Effects = /* @__PURE__ */ ((Effects2) => {
  Effects2["DROP_SHADOW"] = `0px 2px 5px 0px rgba(0, 0, 0, 0.2)`;
  Effects2["DROP_SHADOW_OVERLAY"] = `0px 2px 5px 0px rgba(0, 0, 0, 0.4)`;
  Effects2["DROP_SHADOW_LIGHT"] = `0px 2px 5px 0px rgba(0, 0, 0, 0.1)`;
  return Effects2;
})(Effects || {});

const palette = {
  // @ts-ignore
  primary: {
    main: Palette.DARK_PURPLE,
    dark: Palette.DARKER_PURPLE,
    contrastBackground: Palette.WHITE,
    contrastText: Palette.WHITE,
    background: Palette.DARK_PURPLE_LIGHTER_TRANSPARENT,
    border: Palette.DARK_PURPLE
  },
  secondary: {
    main: Palette.VIOLET,
    dark: Palette.DARKER_VIOLET,
    light: Palette.VIOLET_TRANSPARENT,
    contrastBackground: Palette.WHITE,
    contrastText: Palette.WHITE,
    background: Palette.VIOLET_LIGHTER_TRANSPARENT,
    backgroundAlternate: Palette.LIGHT_VIOLET_TRANSPARENT,
    border: Palette.VIOLET
  },
  text: {
    primary: Palette.DARKER_GRAY,
    secondary: Palette.DARKER_GRAY,
    disabled: Palette.DARK_GRAY
  },
  // @ts-ignore
  success: {
    main: Palette.DARK_GREEN,
    border: Palette.DARK_GREEN,
    background: Palette.GREEN_TRANSPARENT
  },
  // @ts-ignore
  error: {
    main: Palette.RED,
    border: Palette.RED,
    background: Palette.RED_TRANSPARENT,
    contrastText: Palette.WHITE
  },
  // @ts-ignore
  warning: {
    dark: Palette.ORANGE,
    main: Palette.TANGERINE,
    background: Palette.TANGERINE_TRANSPARENT,
    contrastText: Palette.WHITE
  },
  // @ts-ignore
  info: {
    main: Palette.VIOLET,
    border: Palette.VIOLET,
    background: Palette.VIOLET_LIGHTER_TRANSPARENT
  },
  // @ts-ignore
  neutral: {
    dark: Palette.DARK_GRAY,
    main: Palette.GRAY,
    light: Palette.LIGHT_GRAY,
    background: Palette.WHITE,
    backgroundUnchecked: Palette.LIGHT_GRAY
  }
};

const displayFontFamily = "Satoshi, Open Sans, Avenir";
var FontWeights = /* @__PURE__ */ ((FontWeights2) => {
  FontWeights2[FontWeights2["HEAVY"] = 900] = "HEAVY";
  FontWeights2[FontWeights2["EXTRABOLD"] = 800] = "EXTRABOLD";
  FontWeights2[FontWeights2["BOLD"] = 700] = "BOLD";
  FontWeights2[FontWeights2["SEMI"] = 600] = "SEMI";
  FontWeights2[FontWeights2["MEDIUM"] = 500] = "MEDIUM";
  FontWeights2[FontWeights2["NORMAL"] = 400] = "NORMAL";
  FontWeights2[FontWeights2["LIGHT"] = 300] = "LIGHT";
  return FontWeights2;
})(FontWeights || {});
const webTextStyles = {
  largeTitle: {
    lineHeight: "41px"
  },
  title1: {
    lineHeight: "34px",
    letterSpacing: 0.18
  },
  title2: {
    lineHeight: "28px",
    letterSpacing: 0.15
  },
  title3: {
    lineHeight: "25px",
    letterSpacing: 0.15
  },
  headline: {
    lineHeight: "22px",
    letterSpacing: 0.15
  },
  body: {
    lineHeight: "22px",
    letterSpacing: -0.3
  },
  callout: {
    lineHeight: "21px",
    letterSpacing: -0.3
  },
  subHead: {
    lineHeight: "20px",
    letterSpacing: -0.3
  },
  footnote: {
    lineHeight: "18px",
    letterSpacing: -0.15
  },
  caption1: {
    lineHeight: "16px"
  },
  caption2: {
    lineHeight: "13px"
  },
  navigation: {
    lineHeight: "10px"
  }
};
const displayTextStyles = {
  xLargeDisplay: {
    lineHeight: "84px",
    letterSpacing: -1.5
  },
  largeDisplay: {
    lineHeight: "74px",
    letterSpacing: -1
  },
  largeCTA: {
    lineHeight: "42px"
  },
  mediumCTA: {
    lineHeight: "30px"
  },
  largeTitle: {
    lineHeight: "24px"
  },
  mediumTitle: {
    lineHeight: "22px"
  },
  smallTitle: {
    lineHeight: "22px"
  },
  largeButton: {
    lineHeight: "16px"
  },
  mediumButton: {
    lineHeight: "14px"
  },
  smallButton: {
    lineHeight: "12px"
  }
};
const displayWebTextStyes = {
  displayLarge: {
    lineHeight: "82px"
  },
  displayRegular: {
    lineHeight: "72px"
  },
  headlineLarge: {
    lineHeight: "57px"
  },
  headlineMedium: {
    lineHeight: "47px"
  },
  headlineSmall: {
    lineHeight: "37px"
  },
  subHeadBoldLarge: {
    lineHeight: "37px"
  },
  subHeadRegularLarge: {
    lineHeight: "42px"
  },
  subHeadSmall: {
    lineHeight: "27px"
  },
  bodyRegular: {
    lineHeight: "28px"
  },
  bodyDisclaimer: {
    lineHeight: "22px"
  },
  ctaButtonText: {
    lineHeight: "28px"
  },
  textLinkStandard: {
    lineHeight: "28px",
    textDecorationLine: "underline"
  },
  textLinkDisclaimer: {
    lineHeight: "22px",
    textDecorationLine: "underline"
  }
};

const RemSizes = (number) => {
  const remCalculated = number / 16;
  return `${remCalculated.toString()}rem`;
};

const typography = {
  /** Web */
  LargeTitle: {
    fontSize: RemSizes(34),
    lineHeight: webTextStyles.largeTitle.lineHeight
  },
  Title1: {
    fontSize: RemSizes(28),
    lineHeight: webTextStyles.title1.lineHeight,
    letterSpacing: webTextStyles.title1.letterSpacing
  },
  Title2: {
    fontSize: RemSizes(22),
    lineHeight: webTextStyles.title2.lineHeight,
    letterSpacing: webTextStyles.title2.letterSpacing
  },
  Title3: {
    fontSize: RemSizes(20),
    lineHeight: webTextStyles.title3.lineHeight,
    letterSpacing: webTextStyles.title3.letterSpacing
  },
  Headline: {
    fontSize: RemSizes(17),
    lineHeight: webTextStyles.headline.lineHeight,
    letterSpacing: webTextStyles.headline.letterSpacing,
    fontWeight: FontWeights.BOLD
  },
  Body: {
    fontSize: RemSizes(17),
    lineHeight: webTextStyles.body.lineHeight,
    letterSpacing: webTextStyles.body.letterSpacing
  },
  Callout: {
    fontSize: RemSizes(16),
    lineHeight: webTextStyles.callout.lineHeight,
    letterSpacing: webTextStyles.callout.letterSpacing
  },
  Subhead: {
    fontSize: RemSizes(15),
    lineHeight: webTextStyles.subHead.lineHeight,
    letterSpacing: webTextStyles.subHead.letterSpacing
  },
  Footnote: {
    fontSize: RemSizes(13),
    lineHeight: webTextStyles.footnote.lineHeight,
    letterSpacing: webTextStyles.footnote.letterSpacing
  },
  Caption1: {
    fontSize: RemSizes(12),
    lineHeight: webTextStyles.caption1.lineHeight
  },
  Caption2: {
    fontSize: RemSizes(11),
    lineHeight: webTextStyles.caption2.lineHeight
  },
  Navigation: {
    fontSize: RemSizes(9),
    lineHeight: webTextStyles.navigation.lineHeight
  },
  /** Display Text */
  DisplayXLarge: {
    fontSize: RemSizes(72),
    lineHeight: displayTextStyles.xLargeDisplay.lineHeight,
    letterSpacing: displayTextStyles.xLargeDisplay.letterSpacing
  },
  DisplayLarge: {
    fontSize: RemSizes(64),
    lineHeight: displayTextStyles.largeDisplay.lineHeight,
    letterSpacing: displayTextStyles.largeDisplay.letterSpacing
  },
  CTALarge: {
    fontSize: RemSizes(36),
    lineHeight: displayTextStyles.largeCTA.lineHeight
  },
  CTAMedium: {
    fontSize: RemSizes(24),
    lineHeight: displayTextStyles.mediumCTA.lineHeight
  },
  TitleLarge: {
    fontSize: RemSizes(20),
    lineHeight: displayTextStyles.largeTitle.lineHeight
  },
  TitleMedium: {
    fontSize: RemSizes(17),
    lineHeight: displayTextStyles.mediumTitle.lineHeight
  },
  TitleSmall: {
    fontSize: RemSizes(16),
    lineHeight: displayTextStyles.smallTitle.lineHeight
  },
  ButtonLarge: {
    fontSize: RemSizes(14),
    lineHeight: displayTextStyles.largeButton.lineHeight
  },
  ButtonMedium: {
    fontSize: RemSizes(12),
    lineHeight: displayTextStyles.mediumButton.lineHeight
  },
  ButtonSmall: {
    fontSize: RemSizes(10),
    lineHeight: displayTextStyles.smallButton.lineHeight
  },
  /** Display Web Text for Sezzle.com website (Satoshi) */
  DisplayBlackLarge: {
    fontSize: RemSizes(72),
    fontWeight: FontWeights.HEAVY,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.displayLarge.lineHeight
  },
  DisplayBoldLarge: {
    fontSize: RemSizes(72),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.displayLarge.lineHeight
  },
  DisplayBlackRegular: {
    fontSize: RemSizes(62),
    fontWeight: FontWeights.HEAVY,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.displayRegular.lineHeight
  },
  DisplayBoldRegular: {
    fontSize: RemSizes(62),
    lineHeight: displayWebTextStyes.displayRegular.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  HeadlineLarge: {
    fontSize: RemSizes(52),
    lineHeight: displayWebTextStyes.headlineLarge.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  HeadlineMedium: {
    fontSize: RemSizes(42),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.headlineMedium.lineHeight
  },
  HeadlineSmall: {
    fontSize: RemSizes(32),
    lineHeight: displayWebTextStyes.headlineSmall.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  SubHeadBoldLarge: {
    fontSize: RemSizes(32),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadBoldLarge.lineHeight
  },
  SubHeadRegularLarge: {
    fontSize: RemSizes(32),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadRegularLarge.lineHeight
  },
  SubHeadBoldSmall: {
    fontSize: RemSizes(21),
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadSmall.lineHeight
  },
  SubHeadRegularSmall: {
    fontSize: RemSizes(21),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.subHeadSmall.lineHeight
  },
  BodyRegular: {
    fontSize: RemSizes(18),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.bodyRegular.lineHeight
  },
  BodyDisclaimer: {
    fontSize: RemSizes(12),
    fontWeight: FontWeights.NORMAL,
    color: palette.primary.main,
    lineHeight: displayWebTextStyes.bodyDisclaimer.lineHeight
  },
  CTAButtonText: {
    fontSize: RemSizes(21),
    lineHeight: displayWebTextStyes.ctaButtonText.lineHeight,
    fontWeight: FontWeights.BOLD,
    color: palette.primary.main
  },
  TextLinkStandard: {
    fontSize: RemSizes(18),
    fontWeight: FontWeights.BOLD,
    color: palette.secondary.main,
    lineHeight: displayWebTextStyes.textLinkStandard.lineHeight,
    textDecorationLine: displayWebTextStyes.textLinkStandard.textDecorationLine
  },
  TextLinkDisclaimer: {
    fontSize: RemSizes(12),
    fontWeight: FontWeights.BOLD,
    color: palette.secondary.main,
    lineHeight: displayWebTextStyes.textLinkDisclaimer.lineHeight,
    textDecorationLine: displayWebTextStyes.textLinkDisclaimer.textDecorationLine
  }
};

const MuiButtonGroup = {
  styleOverrides: {
    root: {
      fontSize: "1rem",
      borderRadius: "25px"
    }
  }
};

const MUIButton = {
  styleOverrides: {
    root: ({
      ownerState: {
        fullWidth: fw,
        originalSize
      }
    }) => {
      const fullWidth = fw ? "100%" : void 0;
      const size = originalSize === "small" ? "auto" : "100%";
      const width = fullWidth || size;
      const maxWidth = fullWidth || RemSizes(358);
      return {
        width,
        maxWidth,
        textTransform: "none",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: RemSizes(100),
        boxShadow: "none",
        fontFamily: displayFontFamily,
        ":disabled": {
          color: `${palette.text.disabled}`
        },
        ":focus": {
          position: "relative",
          boxShadow: "none"
        },
        // This styling is for a pseudo-element that makes up the inner border displayed
        // when a button is focused
        ":focus:before": {
          content: '" "',
          position: "absolute",
          top: "2px",
          left: "2px",
          right: "2px",
          bottom: "2px",
          background: "transparent",
          border: `1px solid ${palette.neutral.background}`,
          borderRadius: RemSizes(100)
        }
      };
    },
    sizeLarge: {
      fontSize: RemSizes(15),
      lineHeight: RemSizes(24),
      height: RemSizes(48),
      paddingTop: RemSizes(13),
      paddingRight: RemSizes(16),
      paddingBottom: RemSizes(13),
      paddingLeft: RemSizes(16),
      letterSpacing: RemSizes(0.25),
      fontWeight: FontWeights.MEDIUM
    },
    sizeMedium: {
      fontSize: RemSizes(14),
      lineHeight: RemSizes(21),
      height: RemSizes(38),
      paddingTop: RemSizes(8),
      paddingRight: RemSizes(12),
      paddingBottom: RemSizes(8),
      paddingLeft: RemSizes(12),
      letterSpacing: RemSizes(0.4),
      fontWeight: FontWeights.MEDIUM
    },
    sizeSmall: {
      fontSize: RemSizes(13),
      lineHeight: RemSizes(21),
      height: RemSizes(32),
      paddingTop: RemSizes(8),
      paddingRight: RemSizes(12),
      paddingBottom: RemSizes(8),
      paddingLeft: RemSizes(12),
      letterSpacing: RemSizes(0.4),
      fontWeight: FontWeights.MEDIUM
    },
    iconSizeLarge: {
      width: RemSizes(20),
      height: RemSizes(20),
      marginRight: RemSizes(8),
      marginTop: RemSizes(-2)
    },
    iconSizeMedium: {
      width: RemSizes(20),
      height: RemSizes(20),
      marginRight: RemSizes(8),
      marginTop: RemSizes(-2)
    },
    iconSizeSmall: {
      width: RemSizes(14),
      height: RemSizes(14),
      marginRight: RemSizes(8),
      marginTop: RemSizes(-4)
    },
    text: {
      disableRipple: true,
      transition: "none",
      "&:hover, &:focus": {
        textDecoration: "underline",
        backgroundColor: "transparent"
      }
    },
    containedPrimary: {
      // Primary styling
      // Prevent hover darkening
      ":hover": {
        backgroundColor: palette.primary.main
      }
    },
    outlinedPrimary: {
      // Secondary styling
      color: palette.primary.main,
      borderColor: palette.primary.main,
      ":hover": {
        backgroundColor: `${palette.primary.main}0D`
      },
      ":focus": {
        borderColor: `transparent`,
        backgroundColor: `${palette.primary.main}0D`
      },
      ":focus:before": {
        borderColor: palette.neutral.background
      }
    },
    containedError: {
      // Regular error styling
      backgroundColor: palette.error.main,
      ":hover": {
        backgroundColor: palette.error.main
      }
    },
    outlinedWarning: {
      // Secondary error styling
      borderColor: palette.error.main,
      backgroundColor: "transparent",
      color: palette.error.main,
      ":hover": {
        borderColor: palette.error.main,
        backgroundColor: `${palette.error.main}0D`
        /** Red, 4% Opacity */
      },
      ":focus": {
        borderColor: `transparent`,
        backgroundColor: `${palette.error.main}14`
        /** Red, 5% Opacity */
      },
      ":focus:before": {
        borderColor: palette.neutral.background
      }
    },
    // @ts-expect-error Type doesn't think this exists, its fine though
    "&.Mui-disabled": {
      backgroundColor: palette.neutral.light,
      color: palette.neutral.dark
    }
  }
};

const MUITextField = {
  styleOverrides: {
    root: {
      backgroundColor: "transparent",
      color: palette.text.primary,
      "label.MuiInputLabel-root": {
        fontWeight: "500",
        fontSize: "0.938rem",
        lineHeight: "1.313rem",
        letterSpacing: "0.009rem",
        padding: "4px 0px 0px 2px"
      },
      ".MuiInputLabel-root": {
        color: palette.neutral.dark,
        "&.Mui-focused": {
          color: palette.secondary.main
        },
        "&.Mui-error": {
          color: palette.error.main
        }
      },
      /** Styling of variant="filled" */
      /** Note: This is the style that TextField uses by default */
      ".MuiFilledInput-root": {
        borderRadius: "10px",
        backgroundColor: Palette.WHITE,
        border: `1px solid ${palette.neutral.dark}`,
        boxSizing: "border-box",
        height: "58px",
        padding: "1px 16px 1px 1px",
        ".MuiFilledInput-input": {
          fontWeight: "500",
          fontSize: "0.938rem",
          lineHeight: "1.313rem",
          letterSpacing: "0.009rem",
          caretColor: palette.secondary.main
        },
        "&:hover, &.Mui-focused": {
          backgroundColor: Palette.WHITE,
          border: `2px solid ${palette.secondary.main}`,
          padding: "0px 15px 0px 0px"
        },
        "&.MuiFilledInput-underline": {
          "&:before, &:after": {
            borderBottom: "none"
          }
        },
        "&.Mui-disabled": {
          backgroundColor: palette.neutral.light,
          margin: "0px",
          "&:hover": {
            border: `1px solid ${palette.neutral.dark}`
          }
        },
        "&.Mui-error": {
          border: `1px solid ${palette.error.main}`,
          padding: "1px 16px 1px 1px",
          "&:hover, &.Mui-focused": {
            border: `2px solid ${palette.error.main}`,
            padding: "0px 15px 0px 0px"
          }
        }
      },
      /** Styling of variant="outlined" */
      ".MuiOutlinedInput-root": {
        borderRadius: "10px"
      },
      ".MuiInputBase-multiline": {
        height: "unset",
        minHeight: "98px",
        alignItems: "start",
        ".MuiInputBase-input": {
          padding: "12px 0px 12px 12px",
          marginTop: "10px"
        }
      },
      ".MuiFormHelperText-root": {
        fontSize: "0.75rem",
        lineHeight: "1.063rem",
        letterSpacing: "0.025rem",
        fontWeight: 500,
        color: palette.neutral.dark,
        "&.Mui-error": {
          color: palette.error.main
        }
      },
      ".MuiIconButton-root": {
        marginRight: "-8px",
        color: palette.neutral.dark
      }
    }
  }
};

const MUICheckbox = {
  styleOverrides: {
    root: {
      color: Palette.DARK_GRAY,
      "&.Mui-checked": {
        color: palette.secondary.main
      },
      "&.Mui-disabled": {
        color: palette.neutral.main
      }
    }
  }
};

const MUISwitch = {
  styleOverrides: {
    switchBase: {
      // Controls default (unchecked) color for the thumb
      color: palette.neutral.dark,
      // Controls checked color for the thumb
      "&.Mui-checked": {
        color: palette.secondary.main
      },
      "&.Mui-disabled": {
        color: palette.neutral.main
      },
      // Controls disabled color for the track
      "&.Mui-disabled+.MuiSwitch-track": {
        opacity: 1,
        backgroundColor: palette.neutral.backgroundUnchecked
      },
      // Controls checked color for the track
      "&.Mui-checked+.MuiSwitch-track": {
        opacity: 1,
        backgroundColor: palette.secondary.backgroundAlternate
      }
    },
    track: {
      // Controls default (unchecked) color for the track
      backgroundColor: palette.neutral.backgroundUnchecked,
      opacity: 1
    },
    thumb: {
      // Controls default (unchecked) color for the thumb
      boxShadow: Effects.DROP_SHADOW,
      "&.Mui-checked": {
        color: palette.secondary.main
      }
    }
  }
};

const MUILink = {
  styleOverrides: {
    root: {
      fontFamily: displayFontFamily
    }
  }
};

const MuiTab = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      color: Palette.DARK_GRAY,
      textTransform: "none",
      opacity: 1,
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: theme.typography.subtitle2.fontSize,
        padding: theme.spacing(2)
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: theme.typography.body1.fontSize,
        lineHeight: theme.typography.body1.fontSize,
        padding: theme.spacing(2.5)
      }
    })
  }
};

const MUITabs = {
  defaultProps: {
    textColor: "secondary",
    indicatorColor: "secondary"
  },
  styleOverrides: {
    root: {
      // Creates the line under the Tabs
      "div.MuiTabs-flexContainer": {
        borderBottom: `1px solid ${Palette.LIGHT_GRAY}`
      },
      // Color the selected tab purple
      ".Mui-selected": {
        color: Palette.VIOLET
      }
    },
    indicator: {
      height: "1px !important"
    }
  }
};

const MUIPagination = {
  defaultProps: {
    color: "primary",
    size: "large"
  },
  styleOverrides: {
    ul: {
      width: "fit-content"
    },
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }
};

const MuiPaginationItem = {
  defaultProps: {
    sx: {
      typography: "Subhead"
    },
    color: "primary",
    size: "large"
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      ellipsis: {
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: theme.typography.subtitle2.lineHeight,
        letterSpacing: theme.typography.subtitle2.letterSpacing
      },
      textPrimary: {
        "&.MuiPaginationItem-page, &.MuiPaginationItem-ellipsis": {
          color: Palette.DARK_GRAY
        },
        "&.Mui-disabled.MuiPaginationItem-previousNext": {
          color: Palette.GRAY,
          opacity: 1
        },
        "&.MuiPaginationItem-previousNext": {
          color: Palette.VIOLET
        },
        "&.MuiPaginationItem-page.Mui-selected, &.MuiPaginationItem-page:hover, &.MuiPaginationItem-previousNext:hover": {
          color: Palette.VIOLET,
          backgroundColor: Palette.VIOLET_LIGHTER_TRANSPARENT
        }
      },
      text: {
        "&.MuiPaginationItem-page, &.MuiPaginationItem-previousNext, &.MuiPaginationItem-ellipsis": {
          margin: "0 2px"
        }
      }
    })
  }
};

const MUIAlert = {
  styleOverrides: {
    root: {
      backgroundColor: palette.neutral.background,
      border: `1px solid ${palette.neutral.light}`,
      padding: "16px"
    },
    message: {
      width: "100%",
      padding: "4px 0px 0px 0px"
    },
    icon: {
      padding: "0px",
      marginTop: "4px"
    }
  }
};

const MUIDialog = {
  styleOverrides: {
    paper: {
      borderRadius: "10px",
      padding: "24px",
      boxShadow: Effects.DROP_SHADOW_OVERLAY
    }
  },
  defaultProps: {
    maxWidth: "xs"
  }
};

const MUIDialogContent = {
  styleOverrides: {
    root: {
      padding: "12px 0px"
    }
  }
};

const MUIRadio = {
  styleOverrides: {
    root: {
      color: Palette.DARK_GRAY,
      "&.Mui-checked": {
        color: palette.secondary.main
      },
      "&.Mui-disabled": {
        color: palette.neutral.main
      }
    }
  }
};

const MUISelect = {
  styleOverrides: {
    iconFilled: {
      right: RemSizes(20)
    },
    filled: {
      backgroundColor: "transparent"
    }
  }
};

const MUIMenu = {
  styleOverrides: {
    paper: {
      borderRadius: RemSizes(10),
      marginTop: RemSizes(6),
      boxShadow: Effects.DROP_SHADOW_OVERLAY,
      backgroundColor: Palette.WHITE
    }
  }
};

const MUIMenuItem = {
  styleOverrides: {
    root: {
      "&.MuiButtonBase-root": {
        padding: `${RemSizes(12)} ${RemSizes(24)}`,
        fontSize: RemSizes(15),
        fontWeight: FontWeights.MEDIUM,
        lineHeight: RemSizes(21),
        letterSpacing: RemSizes(0.15),
        minHeight: "auto",
        backgroundColor: "transparent",
        "&.Mui-selected": {
          backgroundColor: Palette.LIGHT_GRAY
        },
        "&:hover": {
          backgroundColor: Palette.BACKGROUND
        }
      }
    }
  }
};

const MuiContainer = {
  defaultProps: {
    maxWidth: "sm"
  },
  styleOverrides: {
    maxWidthSm: {
      "@media (min-width: 600px)": {
        maxWidth: "440px"
      }
    }
  }
};

const MuiCard = {
  defaultProps: {
    variant: "outlined"
  },
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => {
      return {
        ////////////////////////
        // BEGIN OUTLINED STYLES
        ////////////////////////
        ...!!ownerState.color && ownerState.variant === "outlined" && {
          border: "none",
          boxShadow: `inset 0 0 1px 1px ${theme.palette[ownerState.color]?.border || theme.palette[ownerState.color].main}`
        },
        //////////////////////
        // END OUTLINED STYLES
        //////////////////////
        ////////////////////////
        // BEGIN CONTAINED STYLES
        ////////////////////////
        ...ownerState.variant === "contained" && {
          border: `1px solid ${theme.palette[ownerState.color]?.border || theme.palette[ownerState.color]?.main || theme.palette.divider}`,
          backgroundColor: theme.palette[ownerState.color]?.background
        }
        //////////////////////
        // END CONTAINED STYLES
        //////////////////////
      };
    }
  }
};

const MuiCardContent = {
  styleOverrides: {
    root: ({
      theme
    }) => {
      return {
        "&:last-child": {
          paddingBottom: `${theme.spacing(2)}`
        }
      };
    }
  }
};

const MuiPaper = {
  styleOverrides: {
    root: {
      borderRadius: "10px"
    }
  }
};

const MuiStepper = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      ".MuiStepIcon-root": {
        color: Palette.BACKGROUND,
        width: "27px",
        height: "27px",
        "&.Mui-active": {
          color: theme.palette.secondary.background,
          border: `1px solid ${theme.palette.secondary.main}`,
          borderRadius: "27px",
          ".MuiStepIcon-text": {
            fill: theme.palette.secondary.main
          }
        },
        ".MuiStepIcon-text": {
          fill: theme.palette.neutral.main
        }
      },
      ".MuiStepConnector-lineVertical": {
        minHeight: "16px"
      },
      ".MuiStepLabel-iconContainer": {
        paddingRight: theme.spacing(1.5)
      }
    })
  }
};

const MuiAccordion = {
  styleOverrides: {
    root: ({
      theme
    }) => ({
      ".MuiAccordionSummary-root": {
        minHeight: "unset"
      },
      ".MuiAccordionSummary-content": {
        margin: `${theme.spacing(2)} 0`
      }
    })
  }
};

const MuiChip = {
  defaultProps: {
    color: "primary"
  },
  styleOverrides: {
    root: ({
      ownerState
    }) => {
      if (ownerState.color === "primary") {
        return {
          background: palette.secondary.main,
          color: palette.secondary.contrastText
        };
      }
      if (ownerState.color === "secondary") {
        return {
          background: palette.neutral.backgroundUnchecked,
          color: palette.neutral.dark
        };
      }
      return {
        background: palette[ownerState.color]?.background,
        color: palette[ownerState.color]?.main
      };
    }
  }
};

const MuiAutocomplete = {
  styleOverrides: {
    root: {
      ".MuiFilledInput-root .MuiFilledInput-input": {
        padding: "25px 0 8px 12px"
      },
      ".MuiInputBase-root.MuiFilledInput-underline.MuiFilledInput-root:hover:before": {
        borderBottom: 0
      }
    }
  }
};

const components = {
  MuiTypography: {
    defaultProps: {
      fontFamily: displayFontFamily
    }
  },
  MuiAccordion,
  MuiAutocomplete,
  MuiButton: MUIButton,
  MuiButtonGroup,
  MuiCard,
  MuiCardContent,
  MuiCheckbox: MUICheckbox,
  MuiChip,
  MuiContainer,
  MuiLink: MUILink,
  MuiPaper,
  MuiSwitch: MUISwitch,
  MuiTextField: MUITextField,
  MuiTab,
  MuiTabs: MUITabs,
  MuiPagination: MUIPagination,
  MuiPaginationItem,
  MuiDialog: MUIDialog,
  MuiDialogContent: MUIDialogContent,
  MuiAlert: MUIAlert,
  MuiRadio: MUIRadio,
  MuiSelect: MUISelect,
  MuiStepper,
  MuiMenu: MUIMenu,
  MuiMenuItem: MUIMenuItem
};

const theme = createTheme({
  palette,
  components
});
theme.typography = {
  pxToRem: RemSizes,
  fontFamily: displayFontFamily,
  fontSize: 14,
  fontWeightBold: FontWeights.BOLD,
  fontWeightLight: FontWeights.LIGHT,
  fontWeightMedium: FontWeights.MEDIUM,
  fontWeightRegular: FontWeights.NORMAL,
  htmlFontSize: 16,
  h1: {
    fontSize: "3.188rem",
    lineHeight: "4.0rem",
    letterSpacing: "0",
    fontWeight: FontWeights.BOLD,
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.25rem",
      lineHeight: "2.813rem",
      letterSpacing: "0"
    }
  },
  h2: {
    fontSize: "2.25rem",
    lineHeight: "2.813rem",
    letterSpacing: "0",
    fontWeight: FontWeights.BOLD,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.625rem",
      lineHeight: "2.188rem",
      letterSpacing: "0"
    }
  },
  h3: {
    fontSize: "1.625rem",
    lineHeight: "2.188rem",
    letterSpacing: "0",
    fontWeight: FontWeights.BOLD,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.313rem",
      lineHeight: "1.75rem",
      letterSpacing: "0.006rem"
    }
  },
  h4: {
    fontSize: "1.313rem",
    lineHeight: "1.75rem",
    letterSpacing: "0.006rem",
    fontWeight: FontWeights.BOLD,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.188rem",
      lineHeight: "1.625rem",
      letterSpacing: "0.006rem"
    }
  },
  h5: {
    fontSize: "1.188rem",
    lineHeight: "1.625rem",
    letterSpacing: "0.006rem",
    fontWeight: FontWeights.BOLD,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.063rem",
      lineHeight: "1.438rem",
      letterSpacing: "0.006rem"
    }
  },
  h6: {
    fontSize: "1.063rem",
    lineHeight: "1.438rem",
    letterSpacing: "0.006rem",
    fontWeight: FontWeights.BOLD
  },
  subtitle1: {
    fontSize: "1.063rem",
    lineHeight: "1.483rem",
    letterSpacing: "0.013rem",
    fontWeight: FontWeights.NORMAL
  },
  subtitle2: {
    fontSize: "0.938rem",
    lineHeight: "1.313rem",
    letterSpacing: "0.009rem",
    fontWeight: FontWeights.NORMAL
  },
  body1: {
    fontSize: "1.063rem",
    lineHeight: "1.438rem",
    letterSpacing: "0.013rem",
    fontWeight: FontWeights.NORMAL,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.938rem",
      lineHeight: "1.313rem",
      letterSpacing: "0.009rem"
    }
  },
  body2: {
    fontSize: "0.938rem",
    lineHeight: "1.313rem",
    letterSpacing: "0.009rem",
    fontWeight: FontWeights.NORMAL,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.813rem",
      lineHeight: "1.063rem",
      letterSpacing: "0.025rem"
    }
  },
  caption: {
    fontSize: "0.813rem",
    lineHeight: "1.063rem",
    letterSpacing: "0.025rem",
    fontWeight: FontWeights.NORMAL
  },
  caption2: {
    fontSize: "0.75rem",
    lineHeight: "1.063rem",
    letterSpacing: "0.025rem",
    fontWeight: FontWeights.NORMAL
  },
  overline: {
    fontSize: "0.688rem",
    lineHeight: "1.063rem",
    letterSpacing: "0.013rem",
    fontWeight: FontWeights.NORMAL
  },
  button: {
    fontFamily: displayFontFamily,
    fontSize: "0.938rem",
    letterSpacing: "0.009rem",
    lineHeight: "1.313rem",
    fontWeight: FontWeights.MEDIUM
  },
  /** DEPRECATED */
  ...typography
};

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    console.log("Error: ", error);
    console.log("Error Info:", errorInfo);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children
    } = this.props;
    if (hasError) {
      return /* @__PURE__ */ jsxs("section", { children: [
        /* @__PURE__ */ jsx("h1", { className: "sezzle-gray center", children: "Oh no! Something happened." }),
        /* @__PURE__ */ jsxs("p", { className: "subtitle-medium dark-gray center m-bot-200 m-top-100", children: [
          "Go to ",
          /* @__PURE__ */ jsx("a", { className: "szl-link", href: "https://sezzle.com", children: "Sezzle homepage." })
        ] })
      ] });
    }
    return children;
  }
}

function MUIThemeProvider({
  children
}) {
  return /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(ThemeProvider, { theme, children }) });
}

function Typography({
  variant = "Body",
  fontWeight,
  children,
  ...props
}) {
  const weightType = () => {
    switch (fontWeight) {
      case "light":
        return FontWeights.LIGHT;
      case "normal":
        return FontWeights.NORMAL;
      case "medium":
        return FontWeights.MEDIUM;
      case "semibold":
        return FontWeights.SEMI;
      case "bold":
        return FontWeights.BOLD;
      case "extrabold":
        return FontWeights.EXTRABOLD;
      case "heavy":
        return FontWeights.HEAVY;
      default: {
        if (typeof fontWeight === "number") {
          return fontWeight;
        }
        return FontWeights.NORMAL;
      }
    }
  };
  return /* @__PURE__ */ jsx(Typography$1, { variant, sx: {
    ...props.sx,
    fontWeight: fontWeight ? weightType() : void 0
  }, ...props, children });
}

function InputWrapperLabel({
  label,
  alignLabel,
  description,
  control,
  sx = {}
}) {
  const labelStyling = {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingTop: label ? "0px" : "4px"
  };
  const formControlLabelStyling = {
    width: "100%",
    margin: "0px",
    alignItems: "start",
    justifyContent: alignLabel === "left" ? "space-between" : "flex-start"
  };
  return /* @__PURE__ */ jsx(FormControlLabel, { labelPlacement: alignLabel === "right" ? "end" : "start", sx: {
    ...formControlLabelStyling,
    ...sx
  }, control, label: /* @__PURE__ */ jsxs(Box, { sx: labelStyling, children: [
    !!label && /* @__PURE__ */ jsx(Typography, { variant: "body2", fontWeight: "medium", color: Palette.BLACK, children: label }),
    !!description && /* @__PURE__ */ jsx(Typography, { variant: "caption", fontWeight: label ? "normal" : "medium", color: label ? Palette.DARK_GRAY : Palette.BLACK, children: description })
  ] }) });
}

function TextField({
  type = "text",
  showHideButton = false,
  margin = "0",
  maxWidth = "100%",
  error = false,
  select,
  SelectProps,
  children,
  sx = {},
  variant = "filled",
  ...props
}) {
  const [showInput, setShowInput] = useState(type !== "password");
  const handleClickShowInput = () => setShowInput(!showInput);
  const typeMemo = useMemo(() => {
    if (!type)
      return void 0;
    if (type !== "password")
      return type;
    return showInput ? "text" : "password";
  }, [type, showInput]);
  const adornment = useMemo(() => {
    if (error && !select) {
      return /* @__PURE__ */ jsx(ErrorOutlineIcon, { color: "error" });
    }
    if (showHideButton) {
      return /* @__PURE__ */ jsx(InputAdornment, { position: "end", children: /* @__PURE__ */ jsx(IconButton, { "aria-label": "toggle password visibility", onClick: handleClickShowInput, sx: {
        mr: "-2px"
      }, edge: "end", children: showInput ? /* @__PURE__ */ jsx(VisibilityOff, {}) : /* @__PURE__ */ jsx(Visibility, {}) }) });
    }
    return void 0;
  }, [error, select, showHideButton, showInput, handleClickShowInput]);
  return /* @__PURE__ */ jsx(MuiTextField, { variant, color: "secondary", error, type: typeMemo, fullWidth: true, sx: {
    maxWidth,
    margin,
    ...sx
  }, InputProps: {
    ...props.InputProps || {},
    // This will be either the visibility button or an error icon
    endAdornment: adornment,
    disableUnderline: true
  }, InputLabelProps: {
    ...props.InputLabelProps || {},
    variant,
    fontWeight: "500"
  }, select, SelectProps, ...props, children: !!select && children });
}

function Switch({
  label,
  description,
  maxWidth = "100%",
  padding = "1rem",
  sx = {},
  ...props
}) {
  return !!label || !!description ? /* @__PURE__ */ jsx(InputWrapperLabel, { sx: {
    padding,
    maxWidth,
    ...sx
  }, control: /* @__PURE__ */ jsx(MuiSwitch, { sx: {
    marginTop: "-6px"
  }, color: "secondary", ...props }), ...{
    label,
    description,
    alignLabel: "left"
  } }) : (
    // no label or description provided, use simple switch
    /* @__PURE__ */ jsx(MuiSwitch, { ...props, color: "secondary", sx })
  );
}

function Button({
  size = "large",
  variant = "Primary",
  loading = false,
  loadingText = "Loading...",
  startIcon,
  children,
  maxWidth,
  sx,
  ...props
}) {
  const variantToColor = {
    Primary: "primary",
    Secondary: "primary",
    Error: "error",
    ErrorSecondary: "warning",
    Tertiary: "primary",
    ErrorTertiary: "error"
  };
  const variantLookup = {
    Primary: "contained",
    Error: "contained",
    Secondary: "outlined",
    ErrorSecondary: "outlined",
    Tertiary: "text",
    ErrorTertiary: "text"
  };
  return /* @__PURE__ */ jsx(MuiButton, { size, color: variantToColor[variant] || variantToColor.Primary, variant: variantLookup[variant] || variantLookup.Tertiary, startIcon: loading && startIcon ? /* @__PURE__ */ jsx(CircularProgress, { sx: {
    mt: size === "small" ? "2px" : 0
  }, size: size === "small" ? 14 : 20, color: "inherit" }) : startIcon, disabled: loading ? true : props.disabled, disableRipple: true, disableFocusRipple: true, ...props, sx: {
    maxWidth,
    ...sx
  }, children: loading ? loadingText : children });
}

function SimpleDialog({
  size,
  body,
  title,
  onClickButton,
  buttonText,
  open,
  onClose,
  sx
}) {
  const renderBody = () => {
    if (!body)
      return null;
    if (typeof body === "string") {
      return /* @__PURE__ */ jsx(Typography, { variant: "caption", children: body });
    }
    return body;
  };
  return /* @__PURE__ */ jsxs(MuiDialog, { maxWidth: "md", PaperProps: {
    sx: {
      width: size === "large" ? "530px" : "340px"
    }
  }, open, onClose, fullWidth: true, sx, children: [
    /* @__PURE__ */ jsx(Box$1, { sx: {
      alignItems: "flex-end",
      display: "flex",
      flexDirection: "column"
    }, children: /* @__PURE__ */ jsx(IconButton, { onClick: onClose, "aria-label": "close dialog", children: /* @__PURE__ */ jsx(CloseIcon, { color: "secondary" }) }) }),
    /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", fontWeight: "bold", align: "center", component: "h2", children: title }),
    /* @__PURE__ */ jsx(DialogContent, { children: renderBody() }),
    !!onClickButton && !!buttonText && /* @__PURE__ */ jsx(Button, { maxWidth: "100%", fullWidth: true, size: "medium", variant: "Primary", onClick: () => {
      onClickButton();
      onClose();
    }, children: buttonText })
  ] });
}

function Pagination({
  siblingCount,
  size,
  ...props
}) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  return /* @__PURE__ */ jsx(MuiPagination, { ...props, siblingCount: matches ? 0 : siblingCount, size: matches ? "small" : size });
}

function Checkbox({
  label,
  description,
  alignLabel = "right",
  maxWidth = "100%",
  padding = "1rem",
  sx = {},
  ...props
}) {
  return !!label || !!description ? /* @__PURE__ */ jsx(InputWrapperLabel, { sx: {
    padding,
    maxWidth,
    ...sx
  }, control: /* @__PURE__ */ jsx(MUICheckbox$1, { sx: {
    marginTop: "-10px"
  }, color: "secondary", ...props }), ...{
    label,
    description,
    alignLabel
  } }) : (
    // no label or description provided, use simple checkbox
    /* @__PURE__ */ jsx(MUICheckbox$1, { ...props, color: "secondary", sx })
  );
}

function getAlertColor(severity) {
  switch (severity) {
    case "info":
      return Palette.ALERT_INFO;
    case "error":
      return Palette.ALERT_ERROR;
    case "success":
      return Palette.ALERT_SUCCESS;
    case "warning":
      return Palette.ALERT_WARNING;
    default:
      return Palette.ALERT_INFO;
  }
}
function getAlertIcon(severity) {
  const color = getAlertColor(severity);
  switch (severity) {
    case "info":
      return /* @__PURE__ */ jsx(InfoOutlinedIcon, { sx: {
        color
      } });
    case "error":
      return /* @__PURE__ */ jsx(ErrorOutlineIcon, { sx: {
        color
      } });
    case "success":
      return /* @__PURE__ */ jsx(CheckCircleOutlineIcon, { color: "success" });
    case "warning":
      return /* @__PURE__ */ jsx(ErrorOutlineIcon, { sx: {
        color: Palette.SUNBURN
      } });
    default:
      return /* @__PURE__ */ jsx(InfoOutlinedIcon, { color: "info" });
  }
}
function getAlertBGColor(severity) {
  switch (severity) {
    case "info":
      return Palette.ALERT_INFO_LIGHTER;
    case "error":
      return Palette.ALERT_ERROR_LIGHTER;
    case "success":
      return Palette.ALERT_SUCCESS_LIGHTER;
    case "warning":
      return Palette.ALERT_WARNING_LIGHTER;
    default:
      return Palette.ALERT_INFO_LIGHTER;
  }
}
const Alert = React.forwardRef(function Alert2({
  title,
  description,
  severity = "info",
  onClose,
  open,
  sx,
  ...props
}, ref) {
  return open === void 0 || open && !!onClose ? /* @__PURE__ */ jsxs(MUIAlert$1, { ref, severity, icon: getAlertIcon(severity), sx: {
    backgroundColor: getAlertBGColor(severity),
    border: 0,
    ...sx
  }, ...props, children: [
    /* @__PURE__ */ jsxs(Box$1, { sx: {
      display: "flex",
      alignItems: "start",
      justifyContent: "space-between",
      width: "100%",
      mt: "4px"
    }, children: [
      /* @__PURE__ */ jsx(AlertTitle, { children: /* @__PURE__ */ jsx(Typography, { color: getAlertColor(severity), variant: "subtitle2", fontWeight: "bold", children: title }) }),
      !!onClose && /* @__PURE__ */ jsx(IconButton, { sx: {
        mt: "-8px",
        padding: "5px"
      }, onClick: onClose, "aria-label": "close alert", children: /* @__PURE__ */ jsx(CloseIcon, { sx: {
        color: palette.neutral.dark
      } }) })
    ] }),
    !!description && /* @__PURE__ */ jsx(Typography, { variant: "caption", fontWeight: "normal", color: getAlertColor(severity), children: description })
  ] }) : /* @__PURE__ */ jsx(Box$1, { ref });
});

function Radio({
  label,
  description,
  maxWidth = "100%",
  padding = "1rem",
  alignLabel = "left",
  sx = {},
  ...props
}) {
  return !!label || !!description ? /* @__PURE__ */ jsx(InputWrapperLabel, { sx: {
    padding,
    maxWidth,
    ...sx
  }, control: /* @__PURE__ */ jsx(MuiRadio, { sx: {
    marginTop: "-10px"
  }, color: "secondary", ...props }), ...{
    label,
    description,
    alignLabel
  } }) : (
    // no label or description provided, use simple radio
    /* @__PURE__ */ jsx(MuiRadio, { ...props, color: "secondary", sx })
  );
}

function Select({
  maxWidth = "100%",
  options,
  SelectProps,
  sx = {},
  ...props
}) {
  const [menuMinWidth, setMenuMinWidth] = useState("");
  const inputRef = useRef(null);
  useEffect(() => {
    setMenuMinWidth(inputRef.current?.node.offsetWidth);
    const handleResize = () => {
      setMenuMinWidth(inputRef.current?.node.offsetWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return /* @__PURE__ */ jsx(TextField, { maxWidth, select: true, inputRef, ...props, SelectProps: {
    IconComponent: ExpandMoreIcon,
    autoWidth: true,
    MenuProps: {
      sx: {
        ".MuiMenu-paper": {
          minWidth: menuMinWidth
        }
      }
    },
    ...SelectProps
  }, sx: {
    ".MuiInputBase-root": {
      cursor: "pointer",
      padding: "0 !important",
      "&:hover": {
        ".MuiSelect-iconFilled": {
          right: RemSizes(19)
        }
      },
      "&.Mui-focused": {
        padding: 0,
        ".MuiSelect-iconFilled": {
          right: RemSizes(19)
        },
        ".MuiInputBase-input": {
          paddingLeft: RemSizes(11)
        }
      },
      "&.Mui-disabled": {
        ".MuiSelect-iconFilled": {
          right: RemSizes(20)
        }
      },
      ".MuiInputBase-input": {
        "&:hover": {
          paddingLeft: RemSizes(11)
        }
      }
    },
    ".MuiFilledInput-root": {
      "&.Mui-focused": {
        ".MuiSelect-iconFilled": {
          color: `${palette.secondary.main}`
        }
      },
      "&.Mui-error": {
        ".MuiSelect-iconFilled": {
          color: `${palette.error.main}`
        }
      }
    },
    ...sx
  }, children: options?.map((option) => /* @__PURE__ */ jsx(MenuItem, { value: option.value, children: option.label }, option.value)) });
}

function SearchTextfield({
  enableClearButton,
  onClear,
  ...props
}) {
  return /* @__PURE__ */ jsx(MuiTextField, { ...props, InputProps: {
    ...props.InputProps,
    startAdornment: /* @__PURE__ */ jsx(InputAdornment$1, { position: "start", children: /* @__PURE__ */ jsx(SearchIcon, { sx: (theme) => ({
      color: theme.palette.secondary.main,
      marginLeft: "15px",
      padding: "2px"
    }) }) }),
    endAdornment: enableClearButton ? /* @__PURE__ */ jsx(InputAdornment$1, { position: "end", children: /* @__PURE__ */ jsx(IconButton, { onClick: onClear, sx: {
      padding: "0px"
    }, disableRipple: true, size: "small", children: /* @__PURE__ */ jsx(ClearIcon, {}) }) }) : void 0
  } });
}
function SearchBar({
  options,
  enableClearButton = false,
  renderInput,
  hintText = "",
  onClear,
  sx,
  ...props
}) {
  const isGrouped = options?.length > 0 && typeof options?.[0] === "object";
  const getOptionLabel = (option) => {
    return isGrouped ? option.value : option;
  };
  const groupBy = (option) => {
    return isGrouped && option.group ? option.group : "";
  };
  return /* @__PURE__ */ jsx(Autocomplete, { PaperComponent: styled(Paper)(({
    theme
  }) => ({
    borderRadius: "15px",
    padding: "20px",
    backgroundColor: theme.palette.neutral.background,
    boxShadow: `0px 4px 20px ${theme.palette.neutral.dark}33`,
    marginTop: "20px"
  })), options, renderInput: renderInput || ((params) => /* @__PURE__ */ jsx(SearchTextfield, { onClear, placeholder: hintText, enableClearButton, ...params })), sx: (theme) => ({
    "& .MuiOutlinedInput-root": {
      borderRadius: "30px!important",
      backgroundColor: Palette.BACKGROUND,
      paddingTop: {
        xs: 0,
        lg: "3px"
      },
      paddingBottom: {
        xs: 0,
        lg: "3px"
      },
      paddingRight: "30px!important",
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.neutral.main
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.neutral.dark
      }
    },
    "& .MuiAutocomplete-input": {
      paddingLeft: "30px",
      "&::placeholder": {
        color: theme.palette.neutral.dark,
        opacity: 1
      }
    },
    "& .MuiAutocomplete-endAdornment": {
      right: "5px"
    },
    // SxProps can be either a function (theme)=>SystemStyleObject or a SystemStyleObject.
    // Spread sx into the underlying autocomplete component. If consumer passes a (theme)=>SystemStyleObject,
    // call and spread it. Otherwise, spread the sx as is.
    ...typeof sx === "function" ? sx(theme) : sx
  }), groupBy: isGrouped ? groupBy : void 0, getOptionLabel, renderOption: (props2, option) => {
    return /* @__PURE__ */ createElement(Typography, { ...props2, variant: "body1", key: option.value || option, sx: {
      padding: "12px 10px!important",
      color: Palette.BLACK,
      cursor: "pointer"
    } }, getOptionLabel(option));
  }, renderGroup: (params) => /* @__PURE__ */ jsxs("li", { style: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  }, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", sx: (theme) => ({
      position: "sticky",
      top: "-8px",
      padding: "4px 10px",
      width: "100%",
      backgroundColor: theme.palette.neutral.background,
      color: theme.palette.neutral.dark,
      textTransform: "uppercase"
    }), children: params.group }),
    params.children
  ] }, params.key), ...props });
}

function Card({
  color,
  ...props
}) {
  return /* @__PURE__ */ jsx(MuiCard$1, { color, ...props });
}

function SpacedChildren({
  children,
  spacing
}) {
  if (!spacing) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsx(Box$1, { sx: {
    display: "flex",
    "& > *": {
      marginRight: spacing
    },
    flex: "none",
    scrollSnapAlign: "start"
  }, children });
}
function getArrowSx(direction) {
  return (theme) => ({
    position: "absolute",
    zIndex: 1,
    margin: 1,
    width: "40px",
    height: "40px",
    left: direction === "left" ? 0 : "auto",
    right: direction === "right" ? 0 : "auto",
    backgroundColor: theme.palette.neutral.background,
    borderRadius: "50%",
    border: `1px solid ${theme.palette.neutral.light}`,
    boxShadow: `0px 2px 5px 0px ${theme.palette.text.primary}33`,
    "&:focus": {
      outline: "none",
      border: `1px solid ${theme.palette.neutral.light}`,
      backgroundColor: theme.palette.neutral.light
    },
    "& .MuiSvgIcon-root": {
      fontSize: 14,
      color: `${theme.palette.text.primary}`
    },
    "&:active": {
      backgroundColor: theme.palette.neutral.light
    }
  });
}
function List({
  children,
  sideScroller,
  scrollAmountInPixels,
  showArrows,
  spacing,
  sx,
  ...props
}) {
  const scrollerRef = useRef(null);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const shouldShowArrows = showArrows !== void 0 ? showArrows : isDesktop;
  const [hovered, setHovered] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    if (!isScrolling) {
      setHovered(false);
    }
  };
  const updateArrowVisibility = () => {
    if (scrollerRef.current) {
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = scrollerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };
  const scroll = (direction) => {
    if (scrollerRef.current) {
      const scrollAmount = scrollAmountInPixels || scrollerRef.current.clientWidth;
      scrollerRef.current.scrollTo({
        left: scrollerRef.current.scrollLeft + (direction === "left" ? -scrollAmount : scrollAmount),
        behavior: "smooth"
      });
      setIsScrolling(true);
      setTimeout(() => {
        setIsScrolling(false);
        updateArrowVisibility();
        if (!scrollerRef.current?.matches(":hover")) {
          setHovered(false);
        }
      }, 200);
    }
  };
  useEffect(() => {
    updateArrowVisibility();
  }, []);
  const shouldShowArrowsAndHovered = showArrows !== void 0 ? showArrows : shouldShowArrows && hovered;
  if (!sideScroller) {
    return /* @__PURE__ */ jsx(MuiList, { sx, ...props, children });
  }
  return /* @__PURE__ */ jsxs(Box$1, { display: "flex", alignItems: "center", position: "relative", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [
    shouldShowArrowsAndHovered && showLeftArrow && /* @__PURE__ */ jsx(IconButton$1, { onClick: () => scroll("left"), disableRipple: true, sx: getArrowSx("left"), children: /* @__PURE__ */ jsx(ArrowBackIosNewIcon, {}) }),
    /* @__PURE__ */ jsx(MuiList, { ref: scrollerRef, sx: {
      display: "flex",
      overflow: "auto",
      scrollSnapType: "x mandatory",
      scrollBehavior: "smooth",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none",
      "-ms-overflow-style": "none",
      "& > *": {
        flex: "none",
        scrollSnapAlign: "start"
      },
      ...sx
    }, ...props, children: /* @__PURE__ */ jsx(SpacedChildren, { spacing, children }) }),
    shouldShowArrowsAndHovered && showRightArrow && /* @__PURE__ */ jsx(IconButton$1, { onClick: () => scroll("right"), disableRipple: true, sx: getArrowSx("right"), children: /* @__PURE__ */ jsx(ArrowForwardIosIcon, {}) })
  ] });
}

const StyledCard$1 = styled(Card)({
  marginBottom: "-1px",
  "&:not(:last-child)": {
    borderBottom: "1px solid transparent"
  },
  "& + :not(:last-child), &:last-child": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  "& + :not(:last-child), &:first-of-type": {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  "&:only-of-type": {
    borderRadius: "10px"
  }
});
function StackableCard({
  children,
  className,
  color,
  sx,
  variant
}) {
  return /* @__PURE__ */ jsx(StyledCard$1, { color, variant, className, sx, children });
}

const StyledCard = styled(StackableCard)(({
  color,
  isSelected,
  theme,
  disabled
}) => {
  const sharedStyles = {
    borderColor: `${theme.palette.secondary.border}`,
    backgroundColor: theme.palette[color]?.background,
    zIndex: "1"
  };
  if (disabled) {
    return {
      cursor: "not-allowed",
      color: `${theme.palette.text.disabled}`
    };
  }
  if (isSelected) {
    return {
      [`&:not([disabled])`]: sharedStyles
    };
  }
  return {
    "&:hover:not([disabled])": sharedStyles
  };
});
function SelectableCard({
  children,
  className,
  label,
  sx,
  value,
  disabled
}) {
  const rGroup = useRadioGroup();
  const isSelected = rGroup?.value === value;
  const selectedProps = isSelected ? {
    color: "secondary",
    variant: "contained"
  } : {};
  return /* @__PURE__ */ jsx(StyledCard, { className, ...selectedProps, isSelected, disabled, sx, children: /* @__PURE__ */ jsx(CardActionArea, { component: "label", role: "", tabIndex: -1, disabled, children: /* @__PURE__ */ jsxs(CardContent, { sx: {
    display: "flex",
    alignItems: label && children ? "start" : "center"
  }, children: [
    /* @__PURE__ */ jsx(MuiRadio, { id: `radio-${value}`, value, disabled }),
    /* @__PURE__ */ jsxs(Grid, { container: true, direction: "column", sx: {
      mt: label && children ? 1 : 0
    }, children: [
      typeof label === "string" ? /* @__PURE__ */ jsx(Typography$2, { variant: "h6", children: label }) : label,
      children
    ] })
  ] }) }) });
}

export { Alert, Button, Card, Checkbox, Effects, InputWrapperLabel, List, MUIThemeProvider, Pagination, Palette, Radio, SearchBar, Select, SelectableCard, SimpleDialog, StackableCard, Switch, TextField, Typography, theme };
